import { IMeetingPlaceLinkToAnyPage } from '@/lib/fragments/meetingPlaceLinkToAnyPage';
import { IMeetingPlacePageOfferItem } from '@/lib/fragments/meetingPlacePageOfferItem';
import { IMeetingPlacePageTenantShopItem } from '@/lib/fragments/meetingPlacePageTenantShopItem';
import {
  EditorialCard,
  LeisurePackageOfferCard,
  ListCard,
  OccationEventCard,
  OccationNewsCard,
  OccationOfferCard,
  ServiceCard,
  ServiceSubCategoryCard,
  SubTenantCard,
  TenantCard,
} from './interfaces/list-card.interface';
import { TTenantTypes } from '@/lib/fragments/meetingPlacePageTenantList';
import { TOccationTypes } from '@/lib/fragments/meetingPlacePageOccations';
import { IMeetingPlacePageServiceItem } from '@/lib/fragments/meetingPlacePageServiceItem';
import { IMeetingPlacePageEditorial } from '@/lib/fragments/meetingPlacePageEditorial';
import { IMeetingPlacePageLeisurePackageOfferItem } from '@/lib/fragments/meetingPlacePageLeisurePackageOfferItem';
import { ILibraryServiceType } from '@/lib/fragments/libraryServiceType';
import { IMeetingPlacePageEventItem } from '@/lib/fragments/meetingPlacePageEventItem';
import { IMeetingPlacePageNewsItem } from '@/lib/fragments/meetingPlacePageNewsItem';
import { IMeetingPlacePageTenantEntertainmentItem } from '@/lib/fragments/meetingPlacePageTenantEntertainmentItem';
import { IMeetingPlacePageTenantFoodBevItem } from '@/lib/fragments/meetingPlacePageTenantFoodBevItem';
import { IMeetingPlacePageLegalDocument } from '@/lib/fragments/meetingPlacePageLegalDocument';
import { IFooter } from '@/lib/fragments/blockFooter';

export const linkHasSVG = (
  page: string | IMeetingPlaceLinkToAnyPage,
): page is IMeetingPlaceLinkToAnyPage => {
  return typeof page !== 'string' && !!page?.linkSvg;
};

// export const footerIsMeetingPlace = (
//   footer: IFooter | IChinaFooter,
// ): footer is IFooter => {
//   return (footer as IFooter)?.blocktype === 'ContentfulBlockFooter';
// };

export const cardIsOffer = (card: ListCard): card is OccationOfferCard => {
  return (card as OccationOfferCard).cardType === 'offer';
};

export const cardIsTenant = (card: ListCard): card is TenantCard => {
  return (card as TenantCard)?.cardType === 'tenant';
};

export const pageIsOffer = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem,
): page is IMeetingPlacePageOfferItem => {
  return (
    (page as IMeetingPlacePageOfferItem)?.__typename === 'MeetingPlacePageOffer'
  );
};

export const pageIsShop = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem,
): page is IMeetingPlacePageTenantShopItem => {
  return (
    (page as IMeetingPlacePageTenantShopItem)?.__typename ===
    'MeetingPlacePageTenantShop'
  );
};

export const pageIsTenantShop = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem,
): page is IMeetingPlacePageTenantShopItem => {
  return (
    (page as IMeetingPlacePageTenantShopItem)?.__typename ===
    'MeetingPlacePageTenantShop'
  );
};

export const pageIsService = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem
    | ILibraryServiceType,
): page is IMeetingPlacePageServiceItem => {
  return (
    (page as IMeetingPlacePageServiceItem)?.__typename ===
    'MeetingPlacePageService'
  );
};

export const pageIsEvent = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem,
): page is IMeetingPlacePageEventItem => {
  return (
    (page as IMeetingPlacePageEventItem)?.__typename === 'MeetingPlacePageEvent'
  );
};

export const pageIsNewsItem = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem,
): page is IMeetingPlacePageNewsItem => {
  return (
    (page as IMeetingPlacePageNewsItem)?.__typename ===
    'MeetingPlacePageNewsItem'
  );
};

export const pageIsTenantEntertainment = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem,
): page is IMeetingPlacePageTenantEntertainmentItem => {
  return (
    (page as IMeetingPlacePageTenantEntertainmentItem)?.__typename ===
    'MeetingPlacePageTenantEntertainment'
  );
};

export const pageIsTenantFoodBeverage = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem,
): page is IMeetingPlacePageTenantFoodBevItem => {
  return (
    (page as IMeetingPlacePageTenantFoodBevItem)?.__typename ===
    'MeetingPlacePageTenantFoodBeverage'
  );
};

export const pageIsEditorial = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem
    | IMeetingPlacePageLegalDocument,
): page is IMeetingPlacePageEditorial => {
  return (
    (page as IMeetingPlacePageEditorial)?.__typename ===
    'MeetingPlacePageEditorial'
  );
};

export const pageIsLeisurePackageOffer = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem,
): page is IMeetingPlacePageLeisurePackageOfferItem => {
  return (
    (page as IMeetingPlacePageLeisurePackageOfferItem)?.__typename ===
    'MeetingPlacePageLeisurePackageOfferItem'
  );
};

export const pageIsServiceSubCategory = (
  page:
    | TTenantTypes
    | TOccationTypes
    | IMeetingPlacePageServiceItem
    | IMeetingPlacePageEditorial
    | IMeetingPlacePageLeisurePackageOfferItem
    | ILibraryServiceType,
) => {
  return (
    (page as ILibraryServiceType)?.__typename === 'ContentfulLibraryServiceType'
  );
};

export const cardIsService = (card: ListCard): card is ServiceCard => {
  return (card as ServiceCard).cardType === 'service';
};

export const cardIsServiceSubCategory = (
  card: ListCard,
): card is ServiceSubCategoryCard => {
  return (card as ServiceSubCategoryCard).cardType === 'service_sub_category';
};

export const cardIsSubTenant = (card: ListCard): card is TenantCard => {
  return (card as SubTenantCard).cardType === 'subTenant';
};

export const cardIsNewsItem = (card: ListCard): card is OccationNewsCard => {
  return (card as OccationNewsCard).cardType === 'news';
};

export const cardIsEvent = (card: ListCard): card is OccationEventCard => {
  return (card as OccationEventCard).cardType === 'event';
};

export const cardIsEditorial = (card: ListCard): card is EditorialCard => {
  return (card as EditorialCard).cardType === 'editorial';
};

export const cardIsLeisurePackageOffer = (
  card: ListCard,
): card is LeisurePackageOfferCard => {
  return (card as LeisurePackageOfferCard).cardType === 'leisurePackageOffer';
};

export const footerIsMeetingPlace = (footer: IFooter): footer is IFooter => {
  return (footer as IFooter)?.blocktype === 'BlockFooter';
};
